import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { MdKeyboard } from "react-icons/md";
import axios from 'axios';
import useAuth from '../../Users/hooks/useAuth';
import PacmanLoader from "react-spinners/PacmanLoader";
import { BsArrowsCollapse, BsArrowsExpand } from "react-icons/bs";

import NarratorIntonation from './NarratorIntonation';
import IntonationFeedbackDisplay from './IntonationFeedbackDisplay';
import AIAssessmentDisplay from './AIAssessmentDisplay';
import SegmentEditor from './SergmentEditor';

// Import UI Components
import { KeyboardHelpModal } from './components/KeyboardHelpModal';
import { MobileHeader } from './components/MobileHeader';
import { NavigationHeader } from './components/NavigationHeader';
import { PlayerControls } from './components/PlayerControls';
import { RecordingSection } from './components/RecordingSection';
import { SentenceDisplay } from './components/SentenceDisplay';

// Custom hook for mobile detection
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(window.innerWidth < 1024);
        };
        
        checkDevice();
        window.addEventListener('resize', checkDevice);
        
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []);

    return isMobile;
};

const SnapsWise = ({subject, file})=>{
    const [modelSize, setModelSize] = useState("turbo");
    const [rate, setRate] = useState(1);
    const [loading, setLoading] = useState(false);
    const mimeType = "audio/webm";
    const [segment, setSegment] = useState({})
    const [editedSegments, setEditedSegments] = useState()
    const [editedSegment, setEditedSegment] = useState()
    const [isgranted, setIsGranted] = useState(false)
    const [stream, setStream] = useState()
    const [audio, setAudio] = useState(null);
    const [buttonState, setButtonState] = useState(true);
    const [assessment, setAssessment] = useState(null);
    const { auth, setAuth } = useAuth();
    const [segments, setSegments] = useState()
    const [broadcastTime, setBroadcastTime] = useState(0)
    
    const [state, setState] = useState({})
    const [focus, setFocus]=useState({})
    const [focused, setEdFocus]=useState()
    
    const [collapse, setCollapse] = useState(false)
    const [translation, setTranslation] = useState()
    
    // State for visualization and layout
    const [showIntonationVisualization, setShowIntonationVisualization] = useState(true);
    const [visualizationView, setVisualizationView] = useState('pitch');
    const [activeTab, setActiveTab] = useState('sentence');
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showKeyboardHelp, setShowKeyboardHelp] = useState(false);
    
    // New state for translation modal
    const [showTranslationModal, setShowTranslationModal] = useState(false);
    const isMobile = useIsMobile();

    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [audioChunks, setAudioChunks] = useState([]);
    const audioref = useRef(null);
    const recordRef = useRef(null);
    const pulseRef = useRef(null);

    const [duration, setDuration] = useState(6)
    const [isPlayingSegment, setIsPlayingSegment] = useState(false);

    let audio_record = new Audio(audio)
    
    const fullaudio = `${process.env.REACT_APP_USER_API_URL}/`+file.full_path
   
    const [currentWord, setCurrentWord] = useState(0)
    
    // Updated word click handler
    const handleWordClick = (word) => {
        getTranslations({"word": word, "tolanguage": "English", "fromlanguage": subject.language});
        
        // Open modal on mobile devices
        if (isMobile) {
            setShowTranslationModal(true);
        }
    };

    // Function to handle saving edited segments
    const handleSaveEditedSegments = async (editedSegmentsToSave) => {
        const token = localStorage.getItem("token");
        const requestData = {
            author: subject.author,
            title: subject.title,
            language: subject.language,
            type: subject.type,
            owner: subject.owner,
            file: file.file,
            size_of_model: modelSize
        };

        console.log("Saving with model_size:", modelSize, requestData);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_USER_API_URL}/whisper/add-edited-segments`,
                {
                    fileinfo: requestData,
                    segments: editedSegmentsToSave
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.data.status === "success") {
                alert(`Edited segments ${response.data.action} successfully!`);
                setEditedSegments(null);
                setEditedSegment(null);
                return true;
            } else {
                throw new Error("Failed to save edited segments");
            }
        } catch (error) {
            console.error("Error saving edited segments:", error);
            alert("Error saving edited segments. Please try again.");
            throw error;
        }
    };

    const timeUpdate = (event) => {
        const currentTime = event.target.currentTime
        setBroadcastTime(currentTime-segment.start)
        
        // Update current word based on playback position
        if (segment.hasOwnProperty("words")) {
            const foundword = segment.words.findIndex((word) => 
                word.start <= currentTime && word.end > currentTime
            );
            if (foundword !== -1 && currentWord !== foundword) {
                setCurrentWord(foundword);
            }
        }
        
        // Only detect segment changes if we're not intentionally playing a specific segment
        if (!isPlayingSegment) {
            var found = segments.find( (segment) => segment.end > currentTime);
            var founded = null
            if (editedSegments) {founded = editedSegments.find( (segment) => segment.end > currentTime);}
            if (founded){if (editedSegment !==founded) {setEditedSegment(founded)}}
            if (found){
                if (segment!==found){
                    console.log("1", found)
                    setSegment(found)
                    setCurrentWord(0)
                }
            }
        }
    }
   
    const sendBlob = ({blob, subject, file, segment}) => {
        const token = localStorage.getItem("token");
        const url = `${process.env.REACT_APP_USER_API_URL}/analysis/upload_blob/${subject.owner}/${subject.language}/${subject.author}/${subject.title}/${file.file}/${subject.type}`
        const formData = new FormData();
        console.log(segment, "blobsegment")
        formData.append('uploaded_file', blob);
        formData.append('sendText',JSON.stringify(segment))
    
        const config = {
            headers: {
            'content-type': blob.type, 
            Authorization: `Bearer ${token}`
            },
        };
        
        axios.post(url, formData, config).then((response) => {
            setAssessment(response.data)
            setLoading(false)
        })
        .catch((error) => {
            console.error("Error uploading file: ", error);
        });
    }  

    const getTranslations = async (info) => {
        const token = localStorage.getItem("token");
                  
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/dictionary/get-translation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(info),
        });
        
        if (response.ok) {
            const json = await response.json();
            setTranslation(json)
        };
    }

    const pulse_frames = [ 
        { transform: "scale(1)", opacity: "1" },
        { transform: "scale(1.1)", opacity: "0.8" },
        { transform: "scale(1)", opacity: "1" },
    ]

    const progress_frames = [ 
        { transform: "translateX(0)" },
        { transform: "translateX(176px)" },
        { transform: "translateX(0)" },
    ]

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setIsGranted(true);
                setStream(streamData)
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    // Add this useEffect to reset state when file changes
    useEffect(() => {
        // Reset all state when file changes
        setSegments(null);
        setAssessment(null);
        setAudio(null);
        setRecordingStatus("inactive");
        setAudioChunks([]);
        setButtonState(true);
        setLoading(false);
        setTranslation(null);
        setCurrentWord(0);
        setBroadcastTime(0);
        setIsPlayingSegment(false);
        setEditedSegments(null);
        setEditedSegment(null);
        
        // Re-fetch segments for the new file
        if (file && file.file) {
            getSegments({"subject": subject, "file": file.file});
        }
    }, [file, subject]);

    useEffect(() => {
        if (navigator) {
        navigator.permissions
            .query({ name: "microphone" })
            .then(async function (result) {
            if (result.state === "granted") {
                if ("MediaRecorder" in window) {
                    try {
                        const streamData = await navigator.mediaDevices.getUserMedia({
                            audio: true,
                            video: false,
                        });
                        setIsGranted(true);
                        setStream(streamData)
                    } catch (err) {
                        alert(err.message);
                    }
                } else {
                    alert("The MediaRecorder API is not supported in your browser.");
                }
            } else if (result.state === "prompt") {
                console.log(prompt)
            } else if (result.state === "denied") {
            }
            });
        } else {
        console.log("navigator is not supported by this browser.");
        }
    }, []);

    useEffect(()=>{
        console.log(segment, " segment 2")
        if (segments) {if (Object.keys(segment).length === 0) {setSegment(segments[0])}};  
        setAssessment(null); 
        setRate(1); 
        setLoading(false); 
        setTranslation()
        setIsPlayingSegment(false);
        setCurrentWord(0);
    },[file, subject, segments, editedSegments])

    const getSegments = async ({subject, file}) => {
    const token = localStorage.getItem("token");
    const outdata={"author":subject.author, 'title': subject.title, 'language':subject.language, 'file': file, "type": subject.type}          
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/whisper/get-segments`, {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(outdata),
    });
    
    if (response.ok) {
        const json = await response.json();
        setSegments(json.segments)
        if (json.model_size) {
            setModelSize(json.model_size);
            console.log("Model size from API:", json.model_size);
        }
    };
}
   
    useEffect(()=>{ 
        getSegments( {"subject": subject, "file":file.file} )
    },[file, subject])

    const startRecording = async () => {
        setRecordingStatus("recording");
        setButtonState(true)
        const media = new MediaRecorder(stream, { type: mimeType });
        mediaRecorder.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };

    const stopRecording = () => {
        setAssessment(null);
        setLoading(true)
        if (recordRef.current){
        recordRef.current.getAnimations().forEach(function (arrayItem) {
            arrayItem.pause()
        });}
      
        setRecordingStatus("inactive");
        setButtonState(false)
        mediaRecorder.current.stop();
        
        mediaRecorder.current.onstop = () => {
            const audioBlob = new Blob(audioChunks, { type: mimeType });
            const audioUrl = URL.createObjectURL(audioBlob);
            sendBlob({"blob": audioBlob, "subject":subject, "file": file, "segment":segment})
            setAudio(audioUrl);
            console.log(audioUrl, audioChunks, audioBlob)
            setAudioChunks([]);
        };
    };

    const Play_record = () => {
        setTimeout(()=> {
            audio_record.currentTime=0;
            audio_record.play()
        }  , 300);
    };

    const currentHandlerRef = useRef(null);
    const newreachedEnd = (segment) => {
        const handler = (event) => {
            const currentTime = event.target.currentTime;
            
            if (currentTime >= segment.end - 0.001) {
                audioref.current.pause();
                audioref.current.currentTime = segment.start;
                audioref.current.removeEventListener('timeupdate', handler);
                currentHandlerRef.current = null;
                setIsPlayingSegment(false);
                setCurrentWord(0);
            }
        };
        return handler;
    };
    const handler = newreachedEnd(segment);

    const currentHandlerRefEd = useRef(null);
    const newreachedEndEd = (segment) => {
        const handlered = (event) => {
            if (event.target.currentTime >= segment.end) {
                audioref.current.pause();
                setEdFocus(focused);
                audioref.current.currentTime = segment.start;
                audioref.current.removeEventListener('timeupdate', handlered);
                currentHandlerRefEd.current = null;
            }
        };
        return handlered;
    };
    const handlered = newreachedEndEd(editedSegment);
    
    useEffect(()=> {
        console.log(segment, "segment 1")
        if (segment){
            if ( segment.hasOwnProperty("end") && segment.hasOwnProperty("start")){ 
                if (segment.end-segment.start > 0) {
                    setDuration(segment.end-segment.start)
                }
            }
        }
    },[segment])
    
    useEffect(() => {
        let audio_duration = duration
    
        if (recordingStatus === 'recording') {
            const timer = setTimeout(() => {
                stopRecording()
            }, 3*audio_duration*1000)

            if (recordRef.current){
                recordRef.current.animate(  
                progress_frames,{ duration: 3*audio_duration*1000 , fill: "forwards", iterations: 1 } 
                );
            }
            if (pulseRef.current) {
                pulseRef.current.animate(  
                pulse_frames,{ duration: 3*audio_duration*1000 , fill: "forwards", iterations: 100 } 
                );
            }
            return () => clearTimeout(timer);
        }
    }, [recordingStatus, duration])

    // Keyboard Navigation Effect
    useEffect(() => {
        const handleKeyPress = (event) => {
            // Only handle if not typing in an input field
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                return;
            }

            switch (event.key) {
                case 'ArrowLeft':
                case 'a':
                case 'A':
                    event.preventDefault();
                    handlePreviousSegment();
                    break;

                case 'ArrowRight':
                case 'd':
                case 'D':
                    event.preventDefault();
                    handleNextSegment();
                    break;

                case ' ':
                    event.preventDefault();
                    handlePlayPause();
                    break;

                case 'r':
                case 'R':
                    event.preventDefault();
                    if (isgranted && recordingStatus === 'inactive') {
                        startRecording();
                    }
                    break;

                case 's':
                case 'S':
                    event.preventDefault();
                    if (recordingStatus === 'recording') {
                        stopRecording();
                    }
                    break;

                case 'p':
                case 'P':
                    event.preventDefault();
                    if (!buttonState && audio) {
                        Play_record();
                    }
                    break;

                case 'Escape':
                    event.preventDefault();
                    handleEscape();
                    break;

                case '?':
                    event.preventDefault();
                    setShowKeyboardHelp(prev => !prev);
                    break;

                case '1':
                    event.preventDefault();
                    setRate(1);
                    if (audioref.current) audioref.current.playbackRate = 1;
                    break;

                case '2':
                    event.preventDefault();
                    setRate(0.5);
                    if (audioref.current) audioref.current.playbackRate = 0.5;
                    break;

                case '3':
                    event.preventDefault();
                    setRate(0.25);
                    if (audioref.current) audioref.current.playbackRate = 0.25;
                    break;

                case 'm':
                case 'M':
                    event.preventDefault();
                    setShowIntonationVisualization(prev => !prev);
                    break;

                case 'v':
                case 'V':
                    event.preventDefault();
                    cycleVisualizationView();
                    break;

                case 't':
                case 'T':
                    event.preventDefault();
                    setActiveTab(prev => prev === 'sentence' ? 'full' : 'sentence');
                    break;
            }
        };

        const handlePreviousSegment = () => {
            if (segment["id"] !== 0 && segments) {
                if (audioref.current) audioref.current.pause();
                if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
                setIsPlayingSegment(false);
                audioref.current.currentTime = segments[segment["id"] - 1]["start"];
                if (audioref.current.paused) {
                    setSegment(segments[segment["id"] - 1]);
                    setCurrentWord(0);
                    setAssessment(null);
                    setLoading(false);
                    setTranslation();
                }
            }
        };

        const handleNextSegment = () => {
            if (segment["id"] <= segments.length - 2 && segments) {
                if (audioref.current) audioref.current.pause();
                if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
                setIsPlayingSegment(false);
                audioref.current.currentTime = segments[segment["id"] + 1]["start"] + 0.01;
                if (audioref.current.paused) {
                    setSegment(segments[segment["id"] + 1]);
                    setCurrentWord(0);
                    setAssessment(null);
                    setLoading(false);
                    setTranslation();
                }
            }
        };

        const handlePlayPause = () => {
            if (audioref.current && segment && segment.hasOwnProperty("start")) {
                if (audioref.current.paused) {
                    setFocus(segment);
                    audioref.current.currentTime = segment["start"];
                    audioref.current.play();
                    if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
                    currentHandlerRef.current = handler;
                    audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
                    setIsPlayingSegment(true);
                } else {
                    audioref.current.pause();
                    setIsPlayingSegment(false);
                }
            }
        };

        const handleEscape = () => {
            if (audioref.current) {
                audioref.current.pause();
                setIsPlayingSegment(false);
            }
            if (recordingStatus === 'recording') {
                stopRecording();
            }
        };

        const cycleVisualizationView = () => {
            const views = ['pitch', 'intensity', 'music', 'colors', 'combined'];
            const currentIndex = views.indexOf(visualizationView);
            const nextIndex = (currentIndex + 1) % views.length;
            setVisualizationView(views[nextIndex]);
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [segment, segments, isgranted, recordingStatus, buttonState, audio, visualizationView, activeTab, handler]);

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.hamburger-button')) {
                setMobileMenuOpen(false);
            }
            if (showKeyboardHelp && !event.target.closest('.keyboard-help') && !event.target.closest('.keyboard-help-button')) {
                setShowKeyboardHelp(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [mobileMenuOpen, showKeyboardHelp]);

    // Handler functions for extracted components
    const handlePreviousSegment = () => {
        if (audioref.current) audioref.current.pause();
        if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
        setIsPlayingSegment(false);

        if (segment["id"] !== 0) {
            audioref.current.currentTime = segments[segment["id"] - 1]["start"];
            if (audioref.current.paused) {
                setSegment(segments[segment["id"] - 1]);
                setCurrentWord(0);
                setAssessment(null);
                setLoading(false);
                setTranslation();
            }
        } else {
            audioref.current.currentTime = segments[0]["start"];
            setSegment(segments[0]);
            setCurrentWord(0);
            setAssessment(null);
            setLoading(false);
            setTranslation();
        }
    };

    const handleNextSegment = () => {
        if (audioref.current) audioref.current.pause();
        if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
        setIsPlayingSegment(false);

        if (segment["id"] <= segments.length - 2) {
            audioref.current.currentTime = segments[segment["id"] + 1]["start"] + 0.01;
            if (audioref.current.paused) {
                setSegment(segments[segment["id"] + 1]);
                setCurrentWord(0);
                setAssessment(null);
                setLoading(false);
                setTranslation();
            }
        } else {
            audioref.current.currentTime = segments[0]["start"];
            setSegment(segments[0]);
            setCurrentWord(0);
            setAssessment(null);
            setLoading(false);
            setTranslation();
        }
    };

    const handlePlaySentence = () => {
        setFocus(segment);
        if (audioref.current) {
            if (audioref.current.paused) {
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
            } else {
                audioref.current.pause();
                audioref.current.currentTime = segment["start"];
                audioref.current.play();
            }

            if (currentHandlerRef.current) audioref.current.removeEventListener("timeupdate", currentHandlerRef.current);
            currentHandlerRef.current = handler;
            audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
            setIsPlayingSegment(true);
        }
    };

    const handleWordPlay = (i, item) => {
        setFocus(segment)
        if (audioref.current) {   
            if (currentHandlerRef.current) {
                audioref.current.removeEventListener('timeupdate', currentHandlerRef.current);
            }
            currentHandlerRef.current = handler;
            audioref.current.addEventListener("timeupdate", currentHandlerRef.current);
            setIsPlayingSegment(true);
            
            const startTime = (i !== 0) ? segment.words[i-1].start : item.start;
            
            if (audioref.current.paused) { 
                audioref.current.currentTime = startTime;
                audioref.current.play()
            } else { 
                audioref.current.pause();
                audioref.current.currentTime = startTime;
                audioref.current.play()
            }
        }
    };

   return (
    <div className='flex flex-col lg:flex-row h-full w-full bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30'>
       
        <KeyboardHelpModal 
            showKeyboardHelp={showKeyboardHelp} 
            setShowKeyboardHelp={setShowKeyboardHelp} 
        />
        
       <MobileHeader 
  mobileMenuOpen={mobileMenuOpen}
  setMobileMenuOpen={setMobileMenuOpen}
  setShowKeyboardHelp={setShowKeyboardHelp}
  activeTab={activeTab}
  setActiveTab={setActiveTab}
  showIntonationVisualization={showIntonationVisualization}
  setShowIntonationVisualization={setShowIntonationVisualization}
  visualizationView={visualizationView}
  setVisualizationView={setVisualizationView}
  // REMOVED: translation and setTranslation
/>

        {/* DESKTOP SIDEBAR */}
        <div className={`hidden lg:flex lg:w-80 xl:w-96 flex-col gap-4 transition-all duration-300 h-full overflow-y-auto p-4 bg-white/20 backdrop-blur-sm border-r border-white/30 ${
            sidebarCollapsed ? 'lg:w-20' : ''
        }`}>
            
            {/* Translation Panel - Desktop */}
            {translation && (
                <div className={`bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0 ${sidebarCollapsed ? 'lg:hidden' : ''}`}>
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                            <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center text-white text-sm">
                                🌐
                            </div>
                            Translation
                        </h3>
                        <button 
                            onClick={()=>{setTranslation()}} 
                            className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200 border border-white/40"
                        >
                            <span className="text-gray-500 text-lg">×</span>
                        </button>
                    </div>
                    {translation.translation[0]?.hasOwnProperty("normalizedSource") ?
                        <div className='text-left space-y-3'>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-3 border border-blue-200/50">
                                <p className='font-semibold text-gray-800'>
                                    {translation.translation[0].normalizedSource} 
                                </p>
                                <p className='text-xs text-gray-500 mt-1'>normalized form</p>
                            </div>
                            <ul className='space-y-2 text-sm'>
                                {translation.translation[0].translations.map((item, i)=>{
                                    return(
                                        <li key={i} className='flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40'>
                                            <span className='font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs'>{i+1}</span>
                                            <span className="text-gray-700 flex-1">{item.displayTarget}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    : 
                    (translation.translation === "missing translation") ? 
                        <div className='text-center text-gray-500 py-4 bg-white/50 rounded-xl border border-white/40'>
                            <div className="text-2xl mb-2">🔍</div>
                            <p>Translation not available</p>
                        </div>
                    :
                        <div className='text-left space-y-3'>
                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-3 border border-green-200/50">
                                <p className='font-semibold text-gray-800'>
                                    {translation.word}
                                </p>
                            </div>
                            <ul className='space-y-2 text-sm'>
                                {translation.translation[0].translations.map((item, i)=>{
                                    return(
                                        <li key={i} className='flex items-start gap-3 p-2 rounded-lg bg-white/50 border border-white/40'>
                                            <span className='font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs'>{i+1}</span>
                                            <span className="text-gray-700 flex-1">{item.text}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    }
                </div>
            )}

            {/* Desktop Sidebar Content */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0">
                <div className="flex items-center justify-between mb-4">
                    <h2 className={`font-bold text-gray-800 text-lg flex items-center gap-2 ${sidebarCollapsed ? 'lg:hidden' : ''}`}>
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center text-white text-sm">
                            🎵
                        </div>
                        Practice Mode
                    </h2>
                    <button
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        className="p-2 hover:bg-white/60 rounded-xl transition-all duration-200 hidden lg:block border border-white/40 shadow-sm"
                        title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                    >
                        {sidebarCollapsed ? 
                            <BsArrowsExpand className="text-gray-500" /> : 
                            <BsArrowsCollapse className="text-gray-500" />
                        }
                    </button>
                </div>

                {/* Tab Navigation */}
                <div className={`flex lg:flex-col gap-3 ${sidebarCollapsed ? 'lg:hidden' : ''}`}>
                    <button
                        className={`flex-1 lg:flex-none text-center py-3 px-4 rounded-xl transition-all duration-300 font-medium text-sm flex items-center justify-center gap-3 group ${
                            activeTab === 'sentence'
                            ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg shadow-blue-500/25 border border-blue-400/30"
                            : "bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md"
                        }`}
                        onClick={() => setActiveTab('sentence')}
                    >
                        <div className={`w-6 h-6 rounded-lg flex items-center justify-center text-sm transition-all duration-300 ${
                            activeTab === 'sentence' ? 'bg-white/20' : 'bg-blue-500/10 group-hover:bg-blue-500/20'
                        }`}>
                            📝
                        </div>
                        <span>By Sentence</span>
                    </button>
                    <button
                        className={`flex-1 lg:flex-none text-center py-3 px-4 rounded-xl transition-all duration-300 font-medium text-sm flex items-center justify-center gap-3 group ${
                            activeTab === 'full'
                            ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg shadow-blue-500/25 border border-blue-400/30"
                            : "bg-white/60 text-gray-600 hover:bg-white/80 border border-white/40 hover:border-white/60 hover:shadow-md"
                        }`}
                        onClick={() => setActiveTab('full')}
                    >
                        <div className={`w-6 h-6 rounded-lg flex items-center justify-center text-sm transition-all duration-300 ${
                            activeTab === 'full' ? 'bg-white/20' : 'bg-blue-500/10 group-hover:bg-blue-500/20'
                        }`}>
                            🎧
                        </div>
                        <span>Full Audio</span>
                    </button>
                </div>
            </div>

            {/* Visualization Controls - Desktop */}
            <div className={`bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-white/40 shadow-lg shadow-blue-500/5 flex-shrink-0 ${sidebarCollapsed ? 'lg:hidden' : ''}`}>
                <div className="flex items-center justify-between mb-4">
                    <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                        <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white text-sm">
                            📊
                        </div>
                        Visualization
                    </h3>
                    <div className="flex items-center gap-2">
                        <span className={`text-sm font-medium ${showIntonationVisualization ? 'text-green-600' : 'text-gray-400'}`}>
                            {showIntonationVisualization ? 'ON' : 'OFF'}
                        </span>
                        <button
                            onClick={() => setShowIntonationVisualization(!showIntonationVisualization)}
                            className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
                                showIntonationVisualization 
                                    ? 'bg-gradient-to-r from-green-500 to-emerald-500 shadow-lg shadow-green-500/25' 
                                    : 'bg-gray-300/60'
                            }`}
                        >
                            <span
                                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-all duration-300 ${
                                    showIntonationVisualization ? 'translate-x-6' : 'translate-x-1'
                                }`}
                            />
                        </button>
                    </div>
                </div>

                {showIntonationVisualization && (
                    <div className="space-y-4">
                        <h4 className="font-medium text-gray-700 text-sm flex items-center gap-2 pl-1">
                            <span className="text-lg">👁️</span>
                            View Type
                        </h4>
                        <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
                            {[
                                { key: 'pitch', icon: '📈', label: 'Pitch', color: 'from-blue-500 to-cyan-500' },
                                { key: 'intensity', icon: '🔊', label: 'Intensity', color: 'from-orange-500 to-red-500' },
                                { key: 'music', icon: '🎵', label: 'Music Notes', color: 'from-purple-500 to-pink-500' },
                                { key: 'colors', icon: '🎨', label: 'Color Words', color: 'from-green-500 to-emerald-500' },
                                { key: 'combined', icon: '🌀', label: 'Combined', color: 'from-indigo-500 to-purple-500' }
                            ].map(({ key, icon, label, color }) => (
                                <button
                                    key={key}
                                    onClick={() => setVisualizationView(key)}
                                    className={`p-4 rounded-xl transition-all duration-300 flex items-center gap-3 group border ${
                                        visualizationView === key 
                                            ? `bg-gradient-to-r ${color} text-white shadow-lg border-transparent transform scale-105` 
                                            : "bg-white/60 text-gray-600 hover:bg-white/80 border-white/40 hover:border-white/60 hover:shadow-md hover:transform hover:scale-105"
                                    }`}
                                >
                                    <span className={`text-lg transition-all duration-300 ${
                                        visualizationView === key ? 'scale-110' : 'group-hover:scale-110'
                                    }`}>
                                        {icon}
                                    </span>
                                    <span className="font-medium text-sm">{label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            
        </div>

        {/* MAIN CONTENT PANEL */}
        <div className='flex-1 flex flex-col h-full bg-gradient-to-br from-white/40 via-blue-50/20 to-purple-50/20 backdrop-blur-sm'>
            
            {/* Keyboard Help Floating Button - Desktop */}
            <div className="hidden lg:block fixed bottom-6 right-6 z-30">
                <button
                    onClick={() => setShowKeyboardHelp(true)}
                    className="keyboard-help-button group p-3 bg-white/80 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg shadow-blue-500/5 hover:bg-white transition-all duration-300"
                    title="Keyboard Shortcuts (Press ?)"
                >
                    <MdKeyboard className="text-gray-600 group-hover:text-blue-600 text-xl transition-colors" />
                </button>
            </div>

            {/* Content Area */}
            <div className='flex-1 overflow-y-auto p-4 lg:p-6'>
                {/* Full Audio Player Section */}
                <div className={`${activeTab === 'full' ? 'block' : 'hidden'} h-full`}>
                    <div className='flex flex-col h-full p-4 lg:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5'>  
                        <div className='flex justify-between items-center mb-6'>
                            <h3 className='text-xl font-bold text-gray-800 flex items-center gap-3'>
                                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center text-white">
                                    🎧
                                </div>
                                Full Audio Book
                            </h3>
                            <div className="flex items-center gap-2">
                                <span className="text-xs text-gray-500 bg-blue-100 px-2 py-1 rounded-lg hidden lg:block">
                                    Press T to switch modes
                                </span>
                                <button 
                                    onClick={()=>{setCollapse(!collapse)}} 
                                    className='p-3 hover:bg-white/60 rounded-xl transition-all duration-200 border border-white/40 shadow-sm'
                                >
                                    {collapse ? 
                                        <BsArrowsExpand className='text-gray-500 text-lg'/> : 
                                        <BsArrowsCollapse className='text-gray-500 text-lg'/>
                                    } 
                                </button>
                            </div>
                        </div>
                        
                        <div className={`${collapse ? "hidden" : "block"} transition-all duration-300 flex-1 flex flex-col gap-6`}>
                            <div className="text-center">
                                <p className='text-gray-600 text-sm mb-4'>Listen to the complete audio book</p> 
                                <audio 
                                    preload="auto" 
                                    controls  
                                    onCanPlay={()=>{setState({"canplay": true})}} 
                                    ref={audioref} 
                                    className='mx-auto w-full max-w-2xl rounded-xl'  
                                    src={fullaudio} 
                                    onTimeUpdate={timeUpdate}  
                                    type="mp3/audio"
                                />
                            </div>
                            
                            {/* Current Sentence Display */}
                            {segments && segment.hasOwnProperty('words') && (
                                <div className='p-5 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-200/50 shadow-sm'>
                                    <h4 className='font-semibold text-gray-800 mb-3 text-center'>Current Sentence</h4>
                                    <div className='flex flex-wrap gap-2 justify-center'>
                                        {segment.words.map((item, i) => (
                                            <span 
                                                key={i}
                                                className={`text-lg font-medium px-3 py-2 rounded-xl transition-all duration-300 ${
                                                    (currentWord === i) 
                                                        ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg shadow-blue-500/25 transform scale-105" 
                                                        : "text-gray-800 bg-white border border-gray-300 hover:bg-gray-50 hover:shadow-md"
                                                }`}
                                            >
                                                {item.text}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {/* Narrator Intonation */}
                            {showIntonationVisualization && segments && segment.hasOwnProperty('words') && (
                                <div className='flex-1 bg-white/60 rounded-2xl border border-white/40 p-5'>
                                    <NarratorIntonation 
                                        subject={subject} 
                                        file={file} 
                                        segment={segment} 
                                        broadcastTime={broadcastTime} 
                                        view={visualizationView}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Sentence Practice Section */}
                {activeTab === 'sentence' && segments && !editedSegments && (
                    <div className="flex flex-col gap-6">
                        <SentenceDisplay
                            segment={segment}
                            subject={subject}
                            currentWord={currentWord}
                            onWordClick={handleWordClick}
                            onWordPlay={handleWordPlay}
                        />
                        
                       {/* Player and Recorder Section - Mobile Optimized */}
<div className='p-4 lg:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5'>
  <NavigationHeader
    segment={segment}
    segments={segments}
    onPrevious={handlePreviousSegment}
    onNext={handleNextSegment}
    previousDisabled={segment["id"] === 0}
    nextDisabled={segment["id"] >= segments.length - 1}
  />
  
  <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
    {/* Player Controls - Full width on mobile */}
    <div className="flex flex-col lg:flex-row items-center gap-4 flex-1 w-full">
      <PlayerControls
        state={state}
        segment={segment}
        rate={rate}
        setRate={setRate}
        onPlaySentence={handlePlaySentence}
        audioref={audioref}
      />
    </div>
    
    {/* Recording Section - Full width on mobile */}
    <div className="w-full lg:flex-1">
      <RecordingSection
        isgranted={isgranted}
        recordingStatus={recordingStatus}
        buttonState={buttonState}
        duration={duration}
        recordRef={recordRef}
        pulseRef={pulseRef}
        onStartRecording={startRecording}
        onStopRecording={stopRecording}
        onPlayback={Play_record}
        onEnableMicrophone={getMicrophonePermission}
      />
    </div>
  </div>
</div>

                        {/* Combined Intonation Visualization Block */}
                        {showIntonationVisualization && (
                            <div className='bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5 overflow-hidden'>
                                <div className="flex flex-col">
                                    {/* Narrator Intonation - Compact */}
                                    {segment.hasOwnProperty('words') && (
                                        <div className="p-4 border-b border-white/20">
                                            <div className="flex items-center gap-2 mb-3">
                                                <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center text-white text-xs">
                                                    🎭
                                                </div>
                                                <h4 className="font-semibold text-gray-700">Narrator</h4>
                                                <span className="text-xs text-gray-500 bg-blue-100 px-2 py-0.5 rounded-full">Reference</span>
                                                <span className="text-xs text-gray-400 ml-auto hidden sm:inline">Press V to cycle views</span>
                                            </div>
                                            <div className="min-h-[200px]">
                                                <NarratorIntonation 
                                                    subject={subject} 
                                                    file={file} 
                                                    segment={segment} 
                                                    broadcastTime={broadcastTime} 
                                                    view={visualizationView}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* User Intonation - Compact */}
                                    {assessment && (
                                        <div className="p-4">
                                            <div className="flex items-center gap-2 mb-3">
                                                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center text-white text-xs">
                                                    🎙️
                                                </div>
                                                <h4 className="font-semibold text-gray-700">Your Voice</h4>
                                                <span className="text-xs text-gray-500 bg-green-100 px-2 py-0.5 rounded-full">Your Recording</span>
                                            </div>
                                            <div className="min-h-[200px]">
                                                <IntonationFeedbackDisplay 
                                                    assessment={assessment}
                                                    segment={segment}
                                                    view={visualizationView}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* No User Recording Yet */}
                                    {!assessment && segment.hasOwnProperty('words') && (
                                        <div className="p-8 text-center">
                                            {loading ? (
                                                <div className="flex flex-col items-center">
                                                    <PacmanLoader
                                                        loading={loading}
                                                        color="#3B82F6"
                                                        size={16}
                                                        aria-label="Analyzing recording"
                                                    />
                                                    <p className="text-gray-600 font-medium mt-3">Analyzing your recording...</p>
                                                </div>
                                            ) : recordingStatus === 'recording' ? (
                                                <div className="flex flex-col items-center">
                                                    <div className="text-3xl mb-3 animate-pulse">🎤</div>
                                                    <p className="text-gray-600 font-medium mb-1">Recording in progress...</p>
                                                    <p className="text-gray-500 text-sm">Speak the sentence above</p>
                                                </div>
                                            ) : (
                                                <div className="flex flex-col items-center">
                                                    <div className="text-3xl mb-3">🎤</div>
                                                    <p className="text-gray-600 font-medium mb-1">Record to see comparison</p>
                                                    <p className="text-gray-500 text-sm">Use the Repeat button to record your voice</p>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* AI Assessment Block */}
                        {assessment && (
                            <div className='p-4 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 backdrop-blur-sm rounded-2xl border border-purple-200/50 shadow-lg shadow-purple-500/5'>
                                {auth.username === 'guest' && (
                                    <div className='text-red-500 text-sm font-semibold text-center mb-3 p-3 bg-red-50 rounded-lg border border-red-200/50'>
                                        AI assessment for registered users only
                                    </div>
                                )}
                                
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-2 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl shadow-lg shadow-purple-500/25">
                                        <span className="text-white text-lg">🤖</span>
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-gray-800">AI Assessment</h3>
                                        <p className="text-gray-600 text-xs">Detailed feedback</p>
                                    </div>
                                </div>
                                
                                <AIAssessmentDisplay 
                                    assessment={assessment}
                                    segment={segment}
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* Segment Editor Component */}
                {editedSegments && (
                    <SegmentEditor
                        segments={segments}
                        editedSegments={editedSegments}
                        setEditedSegments={setEditedSegments}
                        editedSegment={editedSegment}
                        setEditedSegment={setEditedSegment}
                        audioref={audioref}
                        subject={subject}
                        file={file}
                        onSave={handleSaveEditedSegments}
                        onCancel={() => {
                            setEditedSegments(null);
                            setEditedSegment(null);
                        }}
                    />
                )}

                {/* Edit Button */}
                {auth?.role === "ADMIN" && !editedSegments && segments && (
                    <div className='flex justify-center'>
                        <button 
                            className='px-6 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white rounded-lg transition-all duration-300 font-medium shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                            onClick={() => {
                                const mysegments = [...segments]; 
                                const currentSegment = segments.find(s => s.id === segment.id) || segments[0];
                                const mysegment = {...currentSegment}; 
                                setEditedSegments(mysegments); 
                                setEditedSegment(mysegment);
                            }}
                        >
                            Edit Segments
                        </button>
                    </div>
                )}
            </div>
        </div>

        {/* MOBILE TRANSLATION MODAL */}
        {showTranslationModal && translation && (
            <div className="fixed inset-0 z-50 lg:hidden">
                {/* Backdrop */}
                <div 
                    className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                    onClick={() => setShowTranslationModal(false)}
                />
                
                {/* Modal Content - Bottom sheet style for mobile */}
                <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm rounded-t-3xl border-t border-white/30 shadow-2xl max-h-[85vh] overflow-hidden animate-in slide-in-from-bottom-1 duration-300">
                    <div className="p-6 max-h-[85vh] overflow-y-auto">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                            <h2 className="font-bold text-gray-800 text-xl flex items-center gap-3">
                                <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center text-white">
                                    🌐
                                </div>
                                Translation
                            </h2>
                            <button
                                onClick={() => setShowTranslationModal(false)}
                                className="p-2 hover:bg-gray-100 rounded-xl transition-all duration-200"
                            >
                                <span className="text-gray-500 text-2xl">×</span>
                            </button>
                        </div>

                        {/* Translation Content */}
                        <div className="space-y-4">
                            {translation.translation[0]?.hasOwnProperty("normalizedSource") ? (
                                <div className='space-y-4'>
                                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-200/50">
                                        <p className='font-semibold text-gray-800 text-lg'>
                                            {translation.translation[0].normalizedSource} 
                                        </p>
                                        <p className='text-xs text-gray-500 mt-1'>Normalized form</p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                            <span className="text-amber-500">📖</span>
                                            Translations
                                        </h4>
                                        <ul className='space-y-3'>
                                            {translation.translation[0].translations.map((item, i) => (
                                                <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                    <span className='font-bold text-blue-500 bg-blue-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                    <span className="text-gray-700 flex-1">{item.displayTarget}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ) : (translation.translation === "missing translation") ? (
                                <div className='text-center py-8 bg-white/50 rounded-xl border border-gray-200'>
                                    <div className="text-4xl mb-3 opacity-50">🔍</div>
                                    <p className="text-gray-600 font-medium">Translation not available</p>
                                    <p className="text-gray-500 text-sm mt-1">Try a different word</p>
                                </div>
                            ) : (
                                <div className='space-y-4'>
                                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200/50">
                                        <p className='font-semibold text-gray-800 text-lg'>
                                            {translation.word}
                                        </p>
                                        <p className='text-xs text-gray-500 mt-1'>Word to translate</p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                            <span className="text-green-500">📚</span>
                                            Translations
                                        </h4>
                                        <ul className='space-y-3'>
                                            {translation.translation[0].translations.map((item, i) => (
                                                <li key={i} className='flex items-start gap-3 p-3 rounded-xl bg-white/50 border border-gray-200'>
                                                    <span className='font-bold text-green-500 bg-green-100 rounded-lg px-2 py-1 text-xs flex-shrink-0'>{i+1}</span>
                                                    <span className="text-gray-700 flex-1">{item.text}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Close Button */}
                        <div className="mt-8 pt-4 border-t border-gray-200">
                            <button
                                onClick={() => setShowTranslationModal(false)}
                                className="w-full py-3 px-4 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-xl font-medium transition-all duration-300 hover:shadow-lg"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </div>
)
}

export default SnapsWise;